import { useCallback } from 'react';
import { useToast } from './ToastContext';
import { ApiResponse } from 'services/providers/dapv.types';

/**
 * Hook pour afficher des toasts basés sur les réponses API
 */
export const useApiToast = () => {
    const { addToast } = useToast();

    /**
     * Affiche un toast basé sur une réponse API
     */
    const showApiToast = useCallback(
        <T>(
            response: ApiResponse<T>,
            options?: {
                successMessage?: string;
                errorMessage?: string;
                duration?: number;
            }
        ) => {
            const { code, status, data } = response;
            const isSuccess = status >= 200 && status < 300;

            addToast({
                type: isSuccess ? 'success' : 'error',
                message: isSuccess ? options?.successMessage || `Opération réussie (${code})` : options?.errorMessage || `Erreur: ${code}`,
                code,
                status,
                data,
                duration: options?.duration ?? 3000
            });
        },
        [addToast]
    );

    /**
     * Affiche un toast d'erreur pour une erreur générique (non-API)
     */
    const showErrorToast = useCallback(
        (
            error: any,
            options?: {
                message?: string;
                duration?: number;
            }
        ) => {
            const errorMessage = options?.message || (error?.message ? `${error.message}` : 'Une erreur est survenue');

            addToast({
                type: 'error',
                message: errorMessage,
                data: error,
                duration: options?.duration ?? 3000
            });
        },
        [addToast]
    );

    return {
        showApiToast,
        showErrorToast
    };
};
